(function () {
  const TRANSLATIONS = {
    Configure: 'Konfigurer',
    'Configure Product': 'Konfigurer produkt',
    Cancel: 'Annuller',
    'Update Cart': 'Opdater kurv',
  };
  const DPO_CONTEXT_PATTERN = /itoris|dynamicproductoptions|dynamic-product-options|dynamic product options|dpo|productoptions|product-options|configur|cart-options/iu;
  const SAFE_GLOBAL_TERMS = new Set(['Configure', 'Configure Product', 'Update Cart']);

  function compactText(value) {
    return String(value || '').replace(/\s+/gu, ' ').trim();
  }

  function translationForText(value) {
    return TRANSLATIONS[compactText(value)] || '';
  }

  function elementSignature(element) {
    if (!element) return '';
    const attrs = [];
    if (element.id) attrs.push(element.id);
    if (typeof element.className === 'string') attrs.push(element.className);
    if (element.attributes) {
      for (const attr of element.attributes) attrs.push(`${attr.name || ''}=${attr.value || ''}`);
    }
    return attrs.join(' ').toLowerCase();
  }

  function hasDpoCopyContext(element) {
    let current = element;

    for (let depth = 0; current && depth < 8; depth += 1) {
      if (DPO_CONTEXT_PATTERN.test(elementSignature(current))) return true;

      const text = compactText(current.innerText || current.textContent);
      if (text.includes('Configure Product') && (text.includes('Update Cart') || text.includes('Cancel'))) {
        return true;
      }

      current = current.parentElement;
    }

    return false;
  }

  function shouldTranslateTextNode(textNode) {
    const source = compactText(textNode?.nodeValue);
    if (!translationForText(source)) return false;
    if (SAFE_GLOBAL_TERMS.has(source)) return true;
    return hasDpoCopyContext(textNode?.parentElement);
  }

  function preserveOuterWhitespace(source, translated) {
    const leading = String(source || '').match(/^\s*/u)?.[0] || '';
    const trailing = String(source || '').match(/\s*$/u)?.[0] || '';
    return `${leading}${translated}${trailing}`;
  }

  function translateTextNode(textNode) {
    if (!shouldTranslateTextNode(textNode)) return false;

    const translated = translationForText(textNode.nodeValue);
    if (!translated) return false;

    textNode.nodeValue = preserveOuterWhitespace(textNode.nodeValue, translated);
    return true;
  }

  function shouldSkipTextNode(textNode) {
    const tagName = textNode?.parentElement?.tagName;
    return tagName === 'SCRIPT' || tagName === 'STYLE' || tagName === 'TEXTAREA';
  }

  function polishDpoCartCopy(root) {
    const documentRef = root?.ownerDocument || root || document;
    const startNode = root?.documentElement || root?.body || root;
    if (!documentRef?.createTreeWalker || !startNode) return 0;

    const walker = documentRef.createTreeWalker(startNode, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    let node = walker.nextNode();

    while (node) {
      if (!shouldSkipTextNode(node)) textNodes.push(node);
      node = walker.nextNode();
    }

    let changed = 0;
    for (const textNode of textNodes) {
      if (translateTextNode(textNode)) changed += 1;
    }
    return changed;
  }

  function boot() {
    if (typeof document === 'undefined' || !document.createTreeWalker) return;

    let scheduled = false;
    const schedulePolish = () => {
      if (scheduled) return;
      scheduled = true;
      const run = () => {
        scheduled = false;
        polishDpoCartCopy(document);
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(run);
      else setTimeout(run, 0);
    };

    schedulePolish();
    document.addEventListener('DOMContentLoaded', schedulePolish);

    if (typeof MutationObserver !== 'undefined' && document.documentElement) {
      new MutationObserver(schedulePolish).observe(document.documentElement, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  }

  window.NaturrumDpoCartCopyPolish = {
    hasDpoCopyContext,
    polishDpoCartCopy,
    translateTextNode,
    translationForText,
  };

  boot();
})();
